import { Cell } from 'rsuite-table';

export default Cell;
